import React, {createContext, useContext, useEffect, useMemo, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {isCaptureRoute} from '../lib/pwa/pwaSafety';

const CaptureSafetyContext = createContext({hasUnsavedCapture: false});

export function CaptureSafetyProvider({children}) {
  const {pathname} = useLocation();
  const captureRoute = isCaptureRoute(pathname);
  const [hasUnsavedCapture, setHasUnsavedCapture] = useState(false);

  useEffect(() => {
    setHasUnsavedCapture(false);
  }, [pathname]);

  useEffect(() => {
    if (!captureRoute) return undefined;
    const workspace = document.getElementById('workspace-main');
    if (!workspace) return undefined;
    const markUnsaved = event => {
      if (event.target instanceof Element && event.target.closest('form')) setHasUnsavedCapture(true);
    };
    workspace.addEventListener('input', markUnsaved, true);
    workspace.addEventListener('change', markUnsaved, true);
    return () => {
      workspace.removeEventListener('input', markUnsaved, true);
      workspace.removeEventListener('change', markUnsaved, true);
    };
  }, [captureRoute, pathname]);

  useEffect(() => {
    if (!hasUnsavedCapture) return undefined;
    const warnBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warnBeforeUnload);
    return () => window.removeEventListener('beforeunload', warnBeforeUnload);
  }, [hasUnsavedCapture]);

  const value = useMemo(() => ({hasUnsavedCapture}), [hasUnsavedCapture]);
  return <CaptureSafetyContext.Provider value={value}>{children}</CaptureSafetyContext.Provider>;
}

export function useCaptureSafety() {
  return useContext(CaptureSafetyContext);
}
